// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import dataTableStyles from "@awc/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { recentOrdersStyles } from "@awc/Overrides/Widgets/Common/RecentOrders";
import { css } from "styled-components";

recentOrdersStyles.cardList = {
    gridContainer: {
        gap: 0,
    },
};

recentOrdersStyles.noOrdersFoundText = {
    ...dataTableStyles.noResultsText,
};

recentOrdersStyles.dataTable = {
    ...dataTableStyles.dataTable,
};

recentOrdersStyles.noOrdersFoundGridItem = {
    width: 12,
    css: css`
        text-align: center;
        padding: 0;
    `,
};
